$(document).ready(function () {
  const THEME_ATTR = "theme";
  const DARK = "dark";
  const LIGHT = "light";
  const THEME_STORAGE_KEY = "userTheme";

  const $html = $("html");
  const $themeSwitcher = $("#themeSwitcher");

  // Load theme from localStorage or default to LIGHT
  const storedTheme = localStorage.getItem(THEME_STORAGE_KEY) || LIGHT;
  $html.attr(THEME_ATTR, storedTheme);

  // Update icons immediately after page loads
  const initialIcon =
    storedTheme === DARK ? "general/sun.svg" : "general/moon.svg";
  $themeSwitcher.find("img").attr("data-icon", initialIcon);
  applyTheme();

  $themeSwitcher.on("click", function () {
    const currentTheme = $html.attr(THEME_ATTR) || LIGHT;
    const newTheme = currentTheme === LIGHT ? DARK : LIGHT;

    // Update theme attribute
    $html.attr(THEME_ATTR, newTheme);

    // Save the new theme preference
    localStorage.setItem(THEME_STORAGE_KEY, newTheme);

    // Update icon for the switcher button
    const newIconName =
      newTheme === DARK ? "general/sun.svg" : "general/moon.svg";
    $(this).find("img").attr("data-icon", newIconName);

    // Reload icons with your existing function
    applyTheme();
  });
});
